"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartSummaryErrorSection = void 0;
const React = require("react");
const react_1 = require("react");
const RetailLocationsContext_1 = require("../../../contexts/RetailLocationsContext");
const Message_1 = require("../../../../../../components/base/atoms/Message");
const useRetailLocationDeliveryDetails_1 = require("../../../hooks/useRetailLocationDeliveryDetails");
const Currency_1 = require("../../../../../../components/base/atoms/Currency");
const SalesOrderContext_1 = require("../../../contexts/SalesOrderContext");
const OrderTypeContext_1 = require("../../../contexts/OrderTypeContext");
const useRequiredContext_1 = require("../../../../../../hooks/useRequiredContext");
const useRetailLocationAvailability_1 = require("../../../hooks/useRetailLocationAvailability");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CartSummaryErrorSection");
const CartSummaryErrorSection = ({}) => {
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { temporaryAddress } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const { orderType } = (0, useRequiredContext_1.useRequiredContext)(OrderTypeContext_1.OrderTypeContext);
    const { minimumDeliveryAmount } = retailLocation;
    const available = (0, useRetailLocationAvailability_1.useRetailLocationAvailableForOrderType)(retailLocation, orderType);
    const { isValidDeliveryAddress, showMinimumAmountMsg } = (0, useRetailLocationDeliveryDetails_1.useRetailLocationDeliveryDetails)(retailLocation);
    return (React.createElement("div", { className: css("") },
        !available && (React.createElement(Message_1.ErrorMessage, { className: css("error") }, `Restaurant is no longer accepting ${orderType} orders`)),
        !isValidDeliveryAddress(temporaryAddress) && (React.createElement(Message_1.ErrorMessage, { className: css("error") }, "Please enter a complete address for the order to be delivered.")),
        showMinimumAmountMsg && (React.createElement(React.Fragment, null,
            React.createElement(Message_1.ErrorMessage, { className: css("error") },
                "Minimum order amount: ",
                React.createElement(Currency_1.Currency, null, minimumDeliveryAmount),
                React.createElement("div", { className: css("error_info") }, "(Excluding delivery and service fees)"))))));
};
exports.CartSummaryErrorSection = CartSummaryErrorSection;
//# sourceMappingURL=index.js.map